import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PromoBannersQuery from 'Query/PromoBanners.query';
import { fetchQuery } from 'Util/Request';

import PromoBanner from './PromoBanner.component';

/** @namespace Pwa/Component/PromoBanner/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/PromoBanner/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isSignedIn: state.MyAccountReducer.isSignedIn,
});

/** @namespace Pwa/Component/PromoBanner/Container */
export class PromoBannerContainer extends PureComponent {
    static propTypes = {
        section: PropTypes.oneOf([
            'cartTop',
            'cartBottom',
            'cartSM',
            'categoryTop',
            'categorySidebar',
            'productTop',
            'productInfo',
            'productMiddle',
            'productBottom',
            'productSM',
            'checkoutTop',
        ]),
        categoryId: PropTypes.number,
        productId: PropTypes.number,
    };

    state = {
        banners: [],
    };

    sectionsMap = {
        cartTop: 'checkout_cart_index/after.body.start//',
        cartBottom: 'checkout_cart_index/before.body.end//',
        cartSM: 'checkout_cart_index/cart.sm//',
        categoryTop: 'catalog_category_view/after.body.start//',
        categoryBottom: 'catalog_category_view/before.body.end//',
        productTop: 'catalog_product_view/after.body.start//',
        productInfo: 'catalog_product_view/sidebar.main//',
        productMiddle: 'catalog_product_view/main//',
        productBottom: 'catalog_product_view/before.body.end//',
        productSM: 'catalog_product_view/pdp.sm//',
        checkoutTop: 'checkout_index_index/after.body.start//',
    };

    componentDidMount() {
        const { section } = this.props;

        if (section && this.sectionsMap[section]) {
            this.loadPromoBanner();
        }
    }

    componentDidUpdate(prevProps) {
        const { isSignedIn, section } = this.props;
        const { isSignedIn: prevIsSignedIn } = prevProps;

        if (isSignedIn !== prevIsSignedIn && section && this.sectionsMap[section]) {
            this.loadPromoBanner();
        }
    }

    async loadPromoBanner() {
        const { section, categoryId, productId } = this.props;
        const position = this.sectionsMap[section];

        fetchQuery([PromoBannersQuery.getPromoBanner(position, { categoryId, productId })]).then(
            /** @namespace Pwa/Component/PromoBanner/Container/PromoBannerContainer/loadPromoBanner/fetchQuery/then */
            ({ mstBannerPlaceholders }) => {
                if (mstBannerPlaceholders && mstBannerPlaceholders[0] && mstBannerPlaceholders[0]?.banners) {
                    this.setState({
                        banners: mstBannerPlaceholders[0].banners,
                    });
                } else {
                    this.setState({ banners: [] });
                }
            },
            /** @namespace Pwa/Component/PromoBanner/Container/PromoBannerContainer/loadPromoBanner/fetchQuery/then/catch */
            () => {
                this.setState({ banners: [] });
            }
        );
    }

    containerProps() {
        const { banners } = this.state;
        const { section } = this.props;

        return {
            banners,
            section,
        };
    }

    render() {
        return <PromoBanner {...this.containerProps()} />;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromoBannerContainer));
